import {
  GET_NOTIFICATION_RULES,
  ADD_NOTIFICATION_RULE,
  UPDATE_NOTIFICATION_RULE,
  DELETE_NOTIFICATION_RULE,
  GET_NOTIFICATION_RULE_DETAILS,
  UPDATE_NOTIFICATION_RULE_STATUS,
} from "helpers/url_helper";
import { createCrudSlice } from "./createCrudSlice";

const notificationRulesSlice = createCrudSlice({
  name: "roles",
  urls: {
    getList: GET_NOTIFICATION_RULES,
    add: ADD_NOTIFICATION_RULE,
    update: UPDATE_NOTIFICATION_RULE,
    delete: DELETE_NOTIFICATION_RULE,
    updateStatus: UPDATE_NOTIFICATION_RULE_STATUS,
    getDetails: GET_NOTIFICATION_RULE_DETAILS,
  },
  initialFilters: {},
  hasDropdownList: true,
  defaultDropdownData: [],
  additionalThunks: {},
  initialState: {
    items: [],
  },
});

// Export actions
export const { setFilter, resetFilters } = notificationRulesSlice.actions;

// Export thunks
export const {
  getList: getNotificationRules,

  add: addNotificationRule,
  update: updateNotificationRule,
  delete: deleteNotificationRule,
  updateStatus: updateNotificationRuleStatus,
  getDetails: getNotificationRuleDetails,
} = notificationRulesSlice.thunks;

// Export reducer
export default notificationRulesSlice.reducer;
